module.exports = __webpack_public_path__ + "img/teamnote.bc23dd80.png";